// =====================================================================
//  ADAPTER FILE — the ONLY place that talks to the backend.
//  Wire these functions to YOUR app's existing login/auth and API.
//  Nothing else in /rahsia needs to know how auth works.
//
//  Default below: fetch() to the endpoints described in DATA_MODEL.md,
//  sending the host app's auth token. Change BASE_URL / getAuthHeaders()
//  to match your app (e.g. Emergent: process.env.REACT_APP_BACKEND_URL + '/api').
// =====================================================================

// ---- 1) CONFIGURE THESE TWO FOR YOUR APP ---------------------------
const BASE_URL =
  (typeof process !== 'undefined' && process.env && process.env.REACT_APP_BACKEND_URL
    ? process.env.REACT_APP_BACKEND_URL : '') + '/api';

function getAuthHeaders() {
  // Example: your app saves a JWT in localStorage after login.
  // Host app authenticates via httpOnly cookie (credentials: 'include').
  return {};
}
// --------------------------------------------------------------------

async function req(method, path, body) {
  const r = await fetch(BASE_URL + path, {
    method, credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.error || data.detail || 'Server error');
  return data;
}

// ---- DAILY QUIZ ------------------------------------------------------
// Returns { date:'YYYY-MM-DD', question:{id,q,o:[4 options]}, attempt:null|{answer,won}, review:null|{a,e,chosen} }
export const getTodayQuiz = () => req('GET', '/quiz/today');
// Returns { won, current_streak, longest_streak, review:{a,e,chosen} }
export const submitQuizAnswer = (answerIndex) => req('POST', '/quiz/submit', { answer: answerIndex });
// Returns [{ id, name, avatar, current_streak, longest_streak, total_wins }] (max 50)
export const getLeaderboard = () => req('GET', '/leaderboard');

// ---- CREDIT / STATS --------------------------------------------------
// Returns a number (total registered members)
export const getMemberCount = () => req('GET', '/stats').then(s => s.members);

// ---- PUSH REMINDER (OPTIONAL) ----------------------------------------
// Returns { publicKey, hour } — hour is the reminder hour in Malaysia time (20 = 8pm)
export const getPushKey = () => req('GET', '/push/key');
export const pushSubscribe = (subscriptionJson) => req('POST', '/push/subscribe', subscriptionJson);
export const pushUnsubscribe = (endpoint) => req('POST', '/push/unsubscribe', { endpoint });
export const pushTest = () => req('POST', '/push/test');
